import React from 'react';
import * as _ from 'lodash';
import { inject, observer } from 'mobx-react';
import { IActiveCountryMap } from '../../../../../interfaces';
import ListItem from './GQCGSelectedItem';
import GQCountryButton from '../../../../GQCountryPicker/GQCountryButton';
import { DeprecatedCSSProperties } from '../../../../../types/DeprecatedCSSProperties';
import { TweenMax } from 'gsap';
import { IMobxRootState } from 'RootStore';

interface Props {
    selectedIds: number[];
    disabled?: boolean;
    style?: DeprecatedCSSProperties;
    onClick?: (id?: number) => void;
    useSelectable?: boolean;
    selected?: number[];
    licensedCountries?: IActiveCountryMap;
}

@inject(({ countryStore }: IMobxRootState) => {
    return {
        licensedCountries: countryStore.countries.licensedCountries,
    };
})
@observer
export default class GQCGSelectedList extends React.Component<Props> {
    private containerRef: HTMLDivElement = null;
    private anchorX: number = null;
    public componentDidUpdate(prevProps: Props) {
        const prevLen =
            (prevProps.selectedIds && prevProps.selectedIds.length) || 0;
        const nextLen =
            (this.props.selectedIds && this.props.selectedIds.length) || 0;
        TweenMax.fromTo(
            this.containerRef,
            0.3,
            { width: 30 * prevLen },
            { width: 30 * nextLen }
        );
    }
    public render() {
        return (
            <div
                className="gq-cg-selected-list"
                style={this.props.style}
                ref={el => (this.containerRef = el)}
                onMouseDown={this.onMouseDown}
                onClick={this.stopPropagation}>
                {_.map(this.props.selectedIds, id => {
                    const country = this.props.licensedCountries[id];
                    return this.props.useSelectable ? (
                        <GQCountryButton
                            key={id}
                            id={id}
                            onClick={this.props.onClick}
                            isSelected={this.props.selected.includes(id)}
                        />
                    ) : (
                        <ListItem
                            key={id}
                            id={id}
                            name={country.name}
                            disabled={this.props.disabled}
                            onClick={this.props.onClick}
                        />
                    );
                })}
            </div>
        );
    }
    private onMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        this.anchorX = e.pageX;
        window.addEventListener('mousemove', this.onMouseMove);
        window.addEventListener('mouseup', this.onMouseUp);
    };
    private onMouseMove = (e: MouseEvent) => {
        const el = this.containerRef;
        el.scrollLeft = this.anchorX - e.pageX;
        const mainEl = document.getElementById('mainApp');
        if (mainEl) {
            mainEl.classList.add('dragging');
        }
    };
    private onMouseUp = (e: MouseEvent) => {
        e.stopPropagation();
        window.removeEventListener('mousemove', this.onMouseMove);
        window.removeEventListener('mouseup', this.onMouseUp);
        const mainEl = document.getElementById('mainApp');
        if (mainEl) {
            mainEl.classList.remove('dragging');
        }
    };
    private stopPropagation = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
    };
}
